module.exports = __webpack_public_path__ + "static/img/news20_2.107d116.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news20_2.png
// module id = MtuV
// module chunks = 0